import i18n from 'src/i18n';
import SweetAlert from 'src/class/Alerts';
import UtilFactory from 'src/factories/UtilFactory';

const mixinForm = {
  data() {
    return {
      initialModel: {},
    };
  },
  methods: {
    /**
     * Este método sirve para colocarle el seleccionar todos
     * a un select multiple
     * @param {*} data
     * @param {*} nameKey
     * @param {String} nameLabel
     * @returns
     */
    concatAll(
      data,
      nameKey = null,
      nameLabel = i18n.t('uti.mixinMasters.selectAll')
    ) {
      let concat = {};
      if (!nameKey) {
        concat = { id: 0, name: nameLabel };
      } else {
        concat['id'] = 0;
        concat[nameKey] = nameLabel;
      }

      return [concat].concat(data);
    },

    /**
     * Seleccionar todos los elementos de un select multiple
     * @param {*} model
     * @param {*} array_data
     * @param {*} scope
     */
    selectAllFromSelect(model, array_data, scope = null) {
      let util_selects = new UtilFactory(this).getUtilObject('select');
      util_selects.selectAllFromSelect(model, array_data, scope);
    },

    /**
     * Autogenerador de códigos para los registros de base de datos
     * @param {String} module
     * @param {Array} tableData
     * @param {String} field
     */
    async codeGenerator(module, tableData, field = 'code') {
      const codesOn = tableData
        .filter(
          (data) =>
            (data && data.hasOwnProperty('code') && data.code !== null) ||
            (data && !data.hasOwnProperty('code'))
        )
        .map((data) => {
          if (data.hasOwnProperty('code'))
            return Number(String(data.code).replace(/\D/g, ''));
          else return Number(data.replace(/\D/g, ''));
        })
        .sort((a, b) => b - a)
        .filter((code) => !isNaN(code));

      await SweetAlert.default(
        '',
        i18n.t('common_words.generate_code'),
        i18n.t('common_words.generate_code_response')
      ).then((result) => {
        if (result.value) {
          const code = this.generateCode(
            module,
            codesOn && codesOn.length > 0 ? codesOn[0] : 0
          );
          this.$set(this.model, field, code);
        }
      });
    },

    /**
     * Método para generar el código
     * @param {String} module
     * @param {Number[]} consecutive
     * @returns
     */
    generateCode(module, consecutive) {
      const words = module.split(' ');
      const initials = words.map((word) => word[0]);

      const length = 4;
      let number = Number(consecutive) + 1;
      const numberToRepeat = length - number.toString().length;
      let zeros = '';
      if (numberToRepeat > 0) zeros = '0'.repeat(numberToRepeat);

      return `${initials.join('')}${zeros + number.toString()}`;
    },

    /**
     * Obtener el mensaje del error de validación
     * @param {String} fieldName
     * @param {Boolean} useKey
     * @param {String|Number|Object} appendToMessage
     * @returns
     */
    getError(fieldName, useKey = false, appendToMessage = '') {
      if (this.$refs[fieldName]) {
        let requireds = this.$refs[fieldName].$el.getElementsByTagName('input');
        for (let item of requireds) {
          item.focus();
        }
      }

      if (useKey) {
        const valueKey = i18n.t(fieldName);
        if (typeof this.errors.first(fieldName) === 'string') {
          let msg = this.errors
            .first(fieldName)
            .replace(fieldName, `${valueKey}`);

          if (typeof appendToMessage === 'object' && appendToMessage !== null) {
            msg = this.multipleReplace(msg, appendToMessage);
          } else {
            msg += ` ${appendToMessage}`;
          }

          return msg;
        }
      }

      return this.errors.first(fieldName);
    },

    /**
     * Reemplaza múltiples ocurrencias en una cadena.
     * @param {String} text
     * @param {Object} toReplace
     * @returns
     */
    multipleReplace(text, toReplace) {
      let result = text;

      for (const [search, replaceWith] of Object.entries(toReplace)) {
        result = result.split(search).join(replaceWith);
      }

      return result;
    },
  },
  beforeMount() {
    this.initialModel = { ...this.model };
  },
};

export default mixinForm;
